import { Module } from 'vuex';
import { actions } from './actions';
import { mutations } from './mutations';
import { TournamentState } from './types';
import { RootState } from '../types';

const state: TournamentState = {
  requestEditModes: {},
  forumThreadId: undefined,
  tournamentId: undefined,
  requests: [],
  isLoaded: false,
  hasHttpError: false,
};
const namespaced: boolean = true;

export const tournament: Module<TournamentState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
};
